import React, { useContext, useEffect, useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import Select from 'react-select'
import api from '../../services/api'
import Swal from 'sweetalert2'
import { MainContext } from '../../context/MainContext'

const CHANNEL_OPTIONS = [
  { value: 'email', label: 'E-mail' },
]

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ align: [] }],
    ['link'],
    ['clean'],
  ],
}

export default function EmailDispatch() {
  const { setPageTitle, setLoading } = useContext(MainContext)
  const [subject, setSubject] = useState('')
  const [content, setContent] = useState('')
  const [channels, setChannels] = useState<any[]>([CHANNEL_OPTIONS[0]])

  useEffect(() => {
    setPageTitle('Envio de E-mail')
  }, [])

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    try {
      if (!channels.length) {
        return Swal.fire({ title: 'Atenção!', text: 'Selecione ao menos um canal de envio', icon: 'warning' })
      }
      if (!content || content.replace(/<[^>]*>/g, '').trim() === '') {
        return Swal.fire({ title: 'Atenção!', text: 'Conteúdo deve ser informado', icon: 'warning' })
      }
      setLoading(true)
      const result = await api.post('/api/email-dispatch', {
        subject,
        content,
        channels: channels.map((c: any) => c.value),
      })
      Swal.fire({ title: 'Sucesso!', text: result.data.message, icon: 'success' })
      setSubject('')
      setContent('')
      setChannels([CHANNEL_OPTIONS[0]])
    } catch (err: any) {
      Swal.fire({
        title: 'Erro!',
        text: err?.response?.data?.message || err,
        icon: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Enviar e-mail para todos os sócios ativos</h5>
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="mb-3">
              <label className="form-label">
                Canais <i className="text-danger">*</i>
              </label>
              <Select
                isMulti
                options={CHANNEL_OPTIONS}
                value={channels}
                onChange={(selected) => setChannels(selected as any[])}
                noOptionsMessage={() => 'Nenhum canal disponível'}
                placeholder='Selecione os canais'
              />
            </div>
            <div className="mb-3">
              <label className="form-label">
                Título <i className="text-danger">*</i>
              </label>
              <input
                type="text"
                className="form-control"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </div>
            <div className="mb-5">
              <label className="form-label">
                Conteúdo <i className="text-danger">*</i>
              </label>
              <ReactQuill
                theme="snow"
                value={content}
                onChange={setContent}
                modules={QUILL_MODULES}
                style={{ height: 300, marginBottom: 20 }}
              />
            </div>
            <button type="submit" className="btn btn-success">
              <i className="bi bi-envelope-fill">&nbsp;</i>Enviar
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
